import gql from 'graphql-tag';

import { CatchFieldsForPostsViewer } from './fragments/CatchFieldsForPostsViewer';
import { ImageFragments } from './fragments/ImageType';
import { PostCardFragment, PostFragments } from './fragments/PostType';
import { UserFragments } from './fragments/UserType';

export const getProfile = gql`
  query GetProfile($nickname: String!) {
    user(nickname: $nickname) {
      ...UserId
      avatar(croppingStrategy: CENTER, height: 280, width: 280) {
        height
        width
        ...ImageFields
      }
      legacyId: id
      nickname
      firstName
      lastName
      isPremium
      biography
      coverImage(width: 1200) {
        ...ImageFields
      }
      countryCode
      catches {
        totalCount
      }
    }
  }
  ${UserFragments.id}
  ${ImageFragments.imageFields}
`;

export const getProfileByExternalId = gql`
  query GetProfileByExternalId($externalId: String!) {
    user(externalId: $externalId) {
      ...UserId
      avatar(croppingStrategy: CENTER, height: 280, width: 280) {
        height
        width
        ...ImageFields
      }
      legacyId: id
      nickname
      firstName
      lastName
      isPremium
      biography
      coverImage(width: 1200) {
        ...ImageFields
      }
      countryCode
      catches {
        totalCount
      }
    }
  }
  ${UserFragments.id}
  ${ImageFragments.imageFields}
`;

export const getUserIsFollowed = gql`
  query GetUserIsFollowed($nickname: String!) {
    user(nickname: $nickname) {
      followedByCurrentUser
    }
  }
`;

export const getUsersCatches = gql`
  query GetUsersCatches($nickname: String!, $after: String, $first: Int) {
    user(nickname: $nickname) {
      ...UserId
      catches(
        after: $after
        first: $first
        filters: { withPhotos: true, orderByRecent: true, pinnedCatchesFirst: true }
      ) {
        totalCount
        pageInfo {
          startCursor
          hasNextPage
          endCursor
        }
        edges {
          node {
            ...CatchFieldsForPostsViewer
          }
        }
      }
    }
  }
  ${UserFragments.id}
  ${CatchFieldsForPostsViewer}
`;

export const getUsersPosts = gql`
  query GetUsersPosts($nickname: String!, $after: String) {
    user(nickname: $nickname) {
      ...UserId
      posts(
        first: 15
        filters: { published: true, orderByRecent: true, topLevel: true }
        after: $after
      ) {
        pageInfo {
          startCursor
          hasNextPage
          endCursor
        }
        edges {
          node {
            ...PostCardFields
            ...PostProductUnits
            displayProductUnits {
              totalCount
            }
            images(first: 10, width: 600) {
              totalCount
              edges {
                node {
                  ...ImageFields
                }
              }
            }
          }
        }
      }
    }
  }
  ${UserFragments.id}
  ${PostCardFragment}
  ${PostFragments.productUnits}
  ${ImageFragments.imageFields}
`;

export const getNickname = gql`
  query GetNickname($externalId: String!) {
    user(externalId: $externalId) {
      ...UserId
      nickname
    }
  }
  ${UserFragments.id}
`;
